
<template>
  <div>
    <div class='title'> </div>
    <div v-if="loading && !chart_ready" class="d-flex flex-column align-center ma-2">
      <span>Carregando dados...</span>
      <v-progress-circular indeterminate :size="70" :width="7" color="red" class="mb-0"></v-progress-circular>
    </div>
    <line-chart v-if="chart_ready" :chart-data="computedDataset" :options="chartOptions"
      style="height: 300px; padding-top: 20px"></line-chart>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import LineChart from './chartOptLine.vue'
import Api from '@/api/index';

export default {
  name: 'SellLineChart',
  components: {
    LineChart
  },
  props: {
    date_search: {
      type: String,
    },
  },
  data() {
    return {
      key: null,

      loading: false,
      chart_ready: false,

      chartData: {
        datasets: [

        ],
      },
      chartOptions: {
        fill: false,
        responsive: true,
        maintainAspectRatio: false,

        scales: {
          xAxes: [{
            type: 'time',
            display: true,
            // distribution: 'series',
            time: {
              unit: 'day',
              tooltipFormat: 'DD-MM-YYYY',
              displayFormats: {
                day: 'DD',
              }
            },
            scaleLabel: {
              display: true,
              labelString: "Data",
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
            },
            display: true,
            scaleLabel: {
              display: true,
              labelString: "Unidades"
            }
          }]
        },
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            boxWidth: 15
          }
        },
        tooltips: {
          enabled: true,
          mode: 'nearest'
        },
        plugins: {
          zoom: {
            pan: { enabled: false, mode: 'xy', speed: 10, threshold: 10, },
            zoom: { enabled: false, mode: 'xy' },
            limits: {
              y: { min: 0 },
            },
          },
          datalabels: {
            display: false,
            align: 'start',
            anchor: 'end',
            font: {
              weight: 'bold',
              size: 11
            },
            formatter: function (value, context) {
              return context.dataset.label + ' - ' + (context.dataset.data[context.dataIndex].y).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            },

          }
        }
      },
    }
  },
  methods: {
    getReportData() {
      if (this.activeModalityId && this.date_search) {
        this.chart_ready = false
        this.loading = true
        Api.SellerDailyReport.getReportLineData(this.date_search, {
          modality_id: this.activeModalityId
        }).then(r => r.data).then(d => {
          const { timeline } = d || {}
          this.loadChart(timeline)
        }).catch((err) => {
          console.error('Erro ao carregar dados do gráfico:', err)
          this.loading = false
        })
      }
    },
    loadChart(dash_data) {
      if (!dash_data) {


      } else {
        this.chartData.datasets = []


        let data_acumulado = {
          label: 'Venda Acumulada',
          fill: true,
          borderColor: '#249EBF',
          borderWidth: 3,
          pointBorderColor: '#249EBF',
          backgroundColor: 'rgba(0,255,0, 0.3)',
          data: []
        }

        let meta_acumulada = {
          label: 'Meta Acumulada',
          fill: true,
          borderColor: '#0300CE',
          borderWidth: 2,
          pointBorderColor: '#0300CE',
          backgroundColor: 'rgba(0,0,255, 0.2)',
          data: []
        }

        let data_diario = {
          label: 'Venda Diária',
          fill: true,
          borderColor: '#BF472E',
          borderWidth: 2,
          pointBorderColor: '#BF472E',
          backgroundColor: 'rgba(227,110,86,0.82)',
          data: []
        }

        let meta_diaria = {
          label: 'Meta Diária',
          fill: true,
          borderColor: '#7e015d',
          borderWidth: 2,
          pointBorderColor: '#7e015d',
          backgroundColor: 'rgba(241,129,255,0.59)',
          data: []
        }

        dash_data.forEach(el => {
          let { date, d_bags, m_bags, goal_acc, d_goal } = el
          let one_day = {
            x: date,
            y: d_bags,
          }
          let one_acc = {
            x: date,
            y: m_bags,
          }
          let goal = {
            x: date,
            y: goal_acc,
          }

          let day_goal = {
            x: date,
            y: d_goal,
          }

          data_diario.data.push(one_day)
          data_acumulado.data.push(one_acc)
          meta_acumulada.data.push(goal)
          meta_diaria.data.push(day_goal)

        });
        this.chartData.datasets = [data_acumulado, meta_acumulada, data_diario, meta_diaria]
      }

      this.setChartOptions()

      setTimeout(() => {
        this.chart_ready = true
        this.loading = false
      }, 2000);
    },

    setChartOptions() {
      this.chartOptions.scales.xAxes[0].time.unit = 'day'

    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  mounted() {
    this.getReportData()
  },
  computed: {
    computedDataset() {
      return { datasets: this.chartData.datasets }
    },
  },
  watch: {
    activeModalityId(){
      this.getReportData()
    },
    date_search(nv, ov) {
      if (nv) {
        this.getReportData()
      }
    },
  },
}
</script>